import React from 'react'
import styles from './form.styles'
import injectSheet from 'react-jss'
import FormWrapper from '../../../../../form-wrapper/form-wrapper'
import FormHolder from '../../../../../form-holder/form-holder'
import Footer from '../../../../../footer/footer'
import Button from 'pobble-components/dist/button'
import FormRow from '../../../../../form-row/form-row'
import FormLabel from '../../../../../form-label/form-label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import { Formik } from 'formik'
import * as Yup from 'yup'

const Form = ({ classes, onSubmit, pending, error, suggestedEmail }) => (
  <FormWrapper pending={pending}>
    <Formik
      isInitialValid={formik =>
        formik.validationSchema.isValidSync(formik.initialValues)
      }
      onSubmit={onSubmit}
      initialValues={{
        email: suggestedEmail || ''
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .required('Please provide your email')
          .email(`Please provide correct email address`)
      })}>
      {formikProps => {
        const {
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          isValid
        } = formikProps
        return (
          <form onSubmit={handleSubmit}>
            <FormHolder error={error}>
              <FormRow>
                <FormLabel>Email address</FormLabel>
                <FormInput
                  autoFocus
                  center
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  validationError={touched.email && errors.email}
                  inputProps={{
                    autoComplete: 'username email'
                  }}
                />
              </FormRow>
            </FormHolder>
            <Footer dense>
              <Button
                disabled={!isValid}
                tall
                wide
                type="submit"
                className={'metrics__sign-up-email'}>
                Sign up
              </Button>
            </Footer>
          </form>
        )
      }}
    </Formik>
  </FormWrapper>
)

export default injectSheet(styles)(Form)
